import { ApiRoutes } from "../../../../../constants/api";
import { BaseAPI, RequestMethod } from "../../../base";
import { BlogCreateRequestBody, BlogCreateResponse } from "./types";

export class BlogCreateAPI extends BaseAPI<
    BlogCreateRequestBody,
    BlogCreateResponse
> {
    protected route = ApiRoutes.blog.create;
    protected method = RequestMethod.POST;
    protected hasFile = true;

    protected prepareRequest(data: FormData): RequestInit {
        return {
            method: this.method,
            body: data,
        }
    }
}
